module.exports = __webpack_public_path__ + "static/img/product_bg.4c135792.png";